import React, { useEffect, useState } from 'react';
interface PriceInfo {
  currency: string;
  symbol: string;
  price: string;
  oldPrice: string;
  flag: string;
  label: string;
}
const PRICING: Record<string, PriceInfo> = {
  AR: {
    currency: 'ARS',
    symbol: '$',
    price: '19.990',
    oldPrice: '30.990',
    flag: '🇦🇷',
    label: 'ARS'
  },
  CL: {
    currency: 'CLP',
    symbol: '$',
    price: '16.990',
    oldPrice: '29.990',
    flag: '🇨🇱',
    label: 'CLP'
  },
  CO: {
    currency: 'COP',
    symbol: '$',
    price: '57.900',
    oldPrice: '99.900',
    flag: '🇨🇴',
    label: 'COP'
  },
  PE: {
    currency: 'PEN',
    symbol: 'S/',
    price: '55',
    oldPrice: '99',
    flag: '🇵🇪',
    label: 'PEN'
  },
  MX: {
    currency: 'MXN',
    symbol: '$',
    price: '319',
    oldPrice: '599',
    flag: '🇲🇽',
    label: 'MXN'
  },
  ES: {
    currency: 'EUR',
    symbol: '€',
    price: '15',
    oldPrice: '29',
    flag: '🇪🇺',
    label: 'EUR'
  },
  FR: {
    currency: 'EUR',
    symbol: '€',
    price: '15',
    oldPrice: '29',
    flag: '🇪🇺',
    label: 'EUR'
  },
  DE: {
    currency: 'EUR',
    symbol: '€',
    price: '15',
    oldPrice: '29',
    flag: '🇪🇺',
    label: 'EUR'
  },
  IT: {
    currency: 'EUR',
    symbol: '€',
    price: '15',
    oldPrice: '29',
    flag: '🇪🇺',
    label: 'EUR'
  },
  PT: {
    currency: 'EUR',
    symbol: '€',
    price: '15',
    oldPrice: '29',
    flag: '🇪🇺',
    label: 'EUR'
  },
  UY: {
    currency: 'USD',
    symbol: '$',
    price: '14.99',
    oldPrice: '34.99',
    flag: '🇺🇸',
    label: 'USD'
  },
  EC: {
    currency: 'USD',
    symbol: '$',
    price: '14.99',
    oldPrice: '34.99',
    flag: '🇺🇸',
    label: 'USD'
  },
  US: {
    currency: 'USD',
    symbol: '$',
    price: '14.99',
    oldPrice: '34.99',
    flag: '🇺🇸',
    label: 'USD'
  }
};
const DEFAULT_PRICE: PriceInfo = {
  currency: 'USD',
  symbol: '$',
  price: '14.99',
  oldPrice: '34.99',
  flag: '🇺🇸',
  label: 'USD'
};
export function usePricing() {
  const [priceInfo, setPriceInfo] = useState<PriceInfo>(DEFAULT_PRICE);
  const [loading, setLoading] = useState(true);
  const [countryCode, setCountryCode] = useState('US');
  useEffect(() => {
    const detectCountry = async () => {
      try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        const code = data.country_code || 'US';
        setCountryCode(code);
        setPriceInfo(PRICING[code] || DEFAULT_PRICE);
      } catch {
        // Fallback to USD
        setPriceInfo(DEFAULT_PRICE);
      } finally {
        setLoading(false);
      }
    };
    detectCountry();
  }, []);
  const formattedPrice = priceInfo.label === 'EUR' ? `€${priceInfo.price}` : priceInfo.label === 'PEN' ? `S/${priceInfo.price}` : `${priceInfo.label} $${priceInfo.price}`;
  const formattedOldPrice = priceInfo.label === 'EUR' ? `€${priceInfo.oldPrice}` : priceInfo.label === 'PEN' ? `S/${priceInfo.oldPrice}` : `${priceInfo.label} $${priceInfo.oldPrice}`;
  return {
    priceInfo,
    loading,
    countryCode,
    formattedPrice,
    formattedOldPrice
  };
}